import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { createBrowserHistory } from "history"
import { connectRouter, routerMiddleware } from "connected-react-router"
import { persistStore, persistReducer} from "redux-persist"
import storage from 'redux-persist/lib/storage'
import logging from "redux-logger"

import tracking from "./tracker"

import reducer from "./reducer"

/**
 * create and set the store up
 */

function configureStore() {
  // #TODO make this key change automagically with ZSX version
  const persistedReducer = persistReducer({ key: "root-200", storage, blacklist: ["routing", "history", "userInfo"] }, reducer)
  const history = createBrowserHistory()

  const store = createStore(
    connectRouter(history)(persistedReducer),
    compose(
      applyMiddleware(
        thunk,
        tracking,
        routerMiddleware(history),
        // logging(),
        // require('./perf.js')
      ),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  )

  const persistor = persistStore(store)
  // persistor.purge().then(() => console.log("state purged"))

  return { store, history, persistor }
}

export default configureStore



// WEBPACK FOOTER //
// ./src/app/catalogo/store/configureStore.js